/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{AlignPixel as e}from"./AlignPixel.glsl.js";import{multipassTerrainTest as o}from"../shading/MultipassTerrainTest.glsl.js";import{glsl as t}from"../../shaderModules/interfaces.js";function i(i,r){const{vertex:s,fragment:p}=i;s.include(e),r.multipassEnabled&&i.varyings.add("depth","float"),s.code.add(t`
  void main(void) {
    vec4 posProjCenter;
    if (dot(position, position) > 0.0) {
      // Render single point to center of the pixel to avoid subpixel filtering to affect the marker color
      ProjectHUDAux projectAux;
      vec4 posProj = projectPositionHUD(projectAux);
      posProjCenter = alignToPixelCenter(posProj, viewport.zw);

      ${r.multipassEnabled?"depth = projectAux.posView.z;":""}
      vec3 vpos = projectAux.posModel;
      if (rejectBySlice(vpos)) {
        // Project out of clip space
        posProjCenter = vec4(1e038, 1e038, 1e038, 1.0);
      }

    } else {
      // Project out of clip space
      posProjCenter = vec4(1e038, 1e038, 1e038, 1.0);
    }

    gl_Position = posProjCenter;
    gl_PointSize = 1.0;
  }
  `),i.include(o,r),p.code.add(t`
  void main() {
    fragColor = vec4(1);
    ${r.multipassEnabled?t`
        if(terrainDepthTest(depth)) {
          fragColor.g = 0.5;
        }`:""}
  }
  `)}export{i as HUDOcclusionPass};
